import React, { Fragment, useEffect, useState } from 'react';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { Row, Label, Button, Input, Card, CardBody } from 'reactstrap';

const DynamicFlow = ({
  lang,
  channelDetails,
  propertyList,
  integrationId,
  rows,
  setRows,
  propertyAssistant,
  setPropertyAssistant,
}) => {
  console.log("rows:", rows);
  useEffect(() => {
    if (!propertyList?.length) return;

    const savedFlows = channelDetails?.autonomousReplies?.dynamicConversationFlow;

    if (savedFlows?.length > 0) {
      // Ensure row count matches properties count
      const alignedRows = propertyList.map((p) => {
        const saved = savedFlows.find((sf) => sf.propertyId === p.id);
        return {
          propertyId: p.id,
          dynamicConversationFlowId: saved?.dynamicConversationFlowId || "",
        };
      });

      setRows(alignedRows);
    } else {
      // No saved data -> initialize empty rows
      const initial = propertyList.map((p) => ({
        propertyId: p.id,
        dynamicConversationFlowId: "",
      }));
      setRows(initial);
    }

  }, [propertyList, channelDetails]);

  // LOAD CONVERSATION FLOWS PER PROPERTY

  useEffect(() => {
    if (!propertyList?.length) return;

    let assistants = [];

    const loadFlows = async () => {
      const requests = propertyList.map(async (p) => {
        return AxiosAPI({
          methed: "get",
          url: `${gAPI_QuestionSets}/?propertyId=${p.id}&groupId=${getGroupID()}&lang=${lang}`,
        }).then((res) => {
          const sets = res.data.sets?.sort((a, b) => a.displayOrder - b.displayOrder) || [];

          const flows = sets
            .filter(
              (l) =>
                l.type === "DynamicConversationFlow" &&
                l.openAiAssistantId !== ""
            )
            .map((l) => ({
              id: l.openAiAssistantId,
              name: l.name,
            }));

          assistants.push({ pid: p.id, lst: flows });
        });
      });

      await Promise.all(requests);
      setPropertyAssistant(assistants);
    };

    loadFlows();
  }, [propertyList]);

  //HANDLE DROPDOWN CHANGE
  const handleChange = (index, event) => {
    const { name, value } = event.target;

    const updated = [...rows];
    updated[index][name] = value;

    setRows(updated);
  };


  return (
    <Fragment>
      <div className="row mt-2 ml-4 mb-3">
        <h5 style={{ marginTop: '0.15rem' }}>Select Conversation Flows</h5>

        <Row className="w-100 mb-2 mt-2">
          <Colxx md={6}>
            <h6 style={{ fontSize: '14px' }}>Property</h6>
          </Colxx>
          <Colxx md={6}>
            <h6 style={{ fontSize: '14px' }}>Conversation Flow</h6>
          </Colxx>
        </Row>

        {propertyList?.map((property, index) => (
          <Row key={property.id} className="mb-3 mt-2 w-100">

            <Colxx md={6} className="mb-3">
              <div>{property.name}</div>
            </Colxx>

            <Colxx md={6} className="">
              <Input
                type="select"
                name="dynamicConversationFlowId"
                value={rows[index]?.dynamicConversationFlowId || ""}
                onChange={(e) => handleChange(index, e)}
              >
                <option value="">Select a Dynamic Conversation Flow</option>

                {propertyAssistant
                  ?.find((f) => f.pid === property.id)
                  ?.lst?.map((assist, idx) => (
                    <option key={idx} value={assist.id}>
                      {assist.name} ({assist.id})
                    </option>
                  ))}
              </Input>
            </Colxx>

          </Row>
        ))}
      </div>
    </Fragment>
  );
};

export default DynamicFlow;